import { gql } from '@apollo/client';

export const QUERY_HAIR_STYLES = gql`
  query hairStyles {
    hairStyles {
      id
      name
    }
  }
`;
